import Client from './client';

export default class CheckoutSubmitOrderBundles extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  put(organizationId, number, options = {}) {
    return this.makeRequest(`${this.host}/${organizationId}/checkout/bundles/orders/${number}/submit`, {
      ...options,
       method: 'PUT',
    });
  }

}
